import React, { Fragment, useReducer } from "react";
import Routes from "./components";
import { LayoutContext, layoutState, layoutReducer } from "./components/shop";

function App() {
  const [data, dispatch] = useReducer(layoutReducer, layoutState);

  return (
    <Fragment>
      <LayoutContext.Provider value={{ data, dispatch }}>
        <Routes />

        {/* 🔗 Tombol WhatsApp */}
        <a
          href="https://wa.me/6281928539617"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '20px',
            backgroundColor: '#25D366',
            borderRadius: '50%',
            padding: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
            zIndex: 1000,
          }}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png"
            alt="WhatsApp"
            style={{ width: 40, height: 40 }}
          />
        </a>
      </LayoutContext.Provider>
    </Fragment>
  );
}

export default App;

